import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Articolo26, Comune, GruppoValore, IscrittoDropdownDto, ListaQuote, Nazione, Prefisso, Provincia, Quota, Regione, Abilitazione, StatoIscritto, Telefono, Titolo, Universita, CTU, Ordine, AuditLog, Psicoterapeuta, MotivoCancellazione, Iscrizione, Anagrafica, CronologiaSospensioni, AnagraficaResponseDto, FileDto } from '../../model/iscritti-data';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { IscrittiService } from '../../services/iscritti.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DialogDinamicoComponent } from '../dialog-dinamico/dialog-dinamico.component';
import { UnsavedService } from '../../services/unsaved.service';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { environment } from '../../environment/environment';
import { FileSelectEvent } from 'primeng/fileupload';
import { SharedService } from '../../services/shared.service';
import { CnopService } from '../../services/cnop.service';
import { DialogCambioStatoComponent } from '../dialog-cambio-stato/dialog-cambio-stato.component';
import { PrintService } from '../../services/print.service';
import { TabView, TabViewChangeEvent } from 'primeng/tabview';
import { RoleService } from '../../services/role.service';
import { DomandeService } from '../../services/domande.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dettaglio-iscritto',
  templateUrl: './dettaglio-iscritto.component.html',
  styleUrl: './dettaglio-iscritto.component.scss'
})
export class DettaglioIscrittoComponent implements OnInit{

  annotazioni = '';

  // prova per la gestione della regione per i componenti
  alboRole = environment.alboRole;

  notValidChar: string = 'Sono presenti caratteri non validi.';

  immagineIscritto: any;

  fototessera: FileDto|undefined;
  fileToUpload: File | undefined;
  cambioFotoDialog: boolean = false;

  statoIscrittoReadonly = true;

  codiceFiscaleFlag = false;

  modificaInCorsoFlag = false;

  ultimoNumeroIscrizione: number | undefined;

  flagSoggiorno: boolean = false;
  flagSoggiornoIllimitato: boolean = false;
  flagScadenzaSoggiorno: boolean = false;

  //services
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private iscritti_service = inject(IscrittiService);
  private message_service = inject(MessageService);
  private dialog_service = inject(DialogService);
  private cnop_service = inject(CnopService);
  private unsaved_service = inject(UnsavedService);
  public shared_service = inject(SharedService);
  private print_service = inject(PrintService);
  public role_service = inject(RoleService);
  public domande_service = inject(DomandeService);
  public translate = inject(TranslateService);
  private confirmationService = inject(ConfirmationService);

  ref: DynamicDialogRef | undefined;
  checkUnsavedChanges = false;

  text: string | undefined;

  //nuovo iscritto route flag
  nuovoIscritto: boolean | null = null;
  nuovoProvvisorio: boolean | null = null;

  //spinner dei bottoni
  isLoadingSpinner = false;
  syncSpinner = false;

  //id iscritto
  currentId = 0;
  anagraficaId: number|null = null;
  altreIscrizioni: boolean = false;

  //informazioni iniziali iscritto (se non nuovo)
  infoOriginali: Iscrizione | null = null;
  quoteOriginali: Quota[] = [];
  dataConfrontoOriginale: any;

  //dati dei dropdown
  regioniOptions: Regione[] = [];
  nazioni: Nazione[] = [];
  province: Provincia[] = [];
  comuni: Comune[] = [];
  articolo26Options: Articolo26[] = [];
  CTUOptions: CTU[] = [];
  abilitazioneOptions: Abilitazione[] = [];
  psicoterapeutaOptions: Psicoterapeuta[] = [];
  titoloOptions: Titolo[] = [];
  universitaOptions: Universita[] = [];
  motivoCancellazioneOptions: MotivoCancellazione[] = [];
  prefissoOptions: Prefisso[] = [];
  oridiniOptions: Ordine[] = [];
  oridineAttuale: any;
  sospensioni: CronologiaSospensioni[] = [];

  stati: StatoIscritto[] = [
    { id: 1, nome: 'ATTIVO', codiceCnop: 'A' },
    { id: 2, nome: 'SOSPESO', codiceCnop: 'S' },
    { id: 3, nome: 'TRASFERIMENTO', codiceCnop: 'T' },
    { id: 4, nome: 'CANCELLATO', codiceCnop: 'C' },
    { id: 5, nome: 'RADIATO', codiceCnop: 'R' }
  ]

  stato_provvisorio: StatoIscritto = { id: 6, nome: 'PROVVISORIO', codiceCnop: 'P' };

  sessi: GruppoValore[] = [
    { nome: 'Maschio', valore: 'M'},
    { nome: 'Femmina', valore: 'F'}
  ];

  sezioni: GruppoValore[] = [
    { nome: 'Sezione A', valore: 'A'},
    { nome: 'Sezione B', valore: 'B'}
  ];

  statoProcedimento: GruppoValore[] = [
    { nome: 'Aperto', valore: 'A'},
    { nome: 'Chiuso', valore: 'C'}
  ];

  vociStampa: any[] = [];

  selectedPrefisso: Prefisso | undefined;
  filteredComuni: Comune[] = [];
  filteredProvince: Provincia[] = [];
  filteredNazione: Nazione[] = [];
  filteredPrefisso: Prefisso[] = [];
  filteredUniversita: Universita[] = [];
  filteredCTU: CTU[] = [];
  filteredOrdini: Ordine[] = [];

  //numeri telefonici
  listaNumeriSecondari: Telefono[] = [];

  //dati dei pagamenti
  listaData: ListaQuote = {
    lista: [],
    id: null,
    componente: 'readonly'
  }

  //elementi modifica stato dialog
  visible: boolean = false;
  selectedStato: StatoIscritto | undefined;

  //elementi del bottone stampa
  caricaVociStampa(tesserino: boolean){
    this.vociStampa = [
      {
        label: 'Scheda Personale',
        command: () => { this.stampaSchedaIscritto() }
      },
      {
        label: 'Certificato Iscrizione',
        command: () => { this.stampaCertidficatoIscrizione() }
      },
      {
        label: 'Certificato Iscrizione Estero',
        command: () => { this.stampaCertidficatoIscrizioneEstero() }
      },
      {
        label: 'Tesserino',
        command: () => { this.stampaTesserino(false) },
        visible: tesserino
      },
      {
        label: 'Tesserino con ALIAS',
        command: () => { this.stampaTesserino(true) },
        visible: tesserino
      }
    ];
  }

  //iscritto form control
  iscrittoForm = new FormGroup({
    anagrafica: new FormGroup({
      codiceFiscale: new FormControl<string|null>(null, [Validators.required, Validators.pattern(/^[^<>{}\[\]()\",;!|\\/?^&%$£:#*]+$/), this.customLenghtValidator(16)]),
      nome: new FormControl<string|null>(null, [Validators.required, Validators.pattern(/^[^<>{}\[\]()\",;!|\\/?^&%$£:#*]+$/)]),
      cognome: new FormControl<string|null>(null, [Validators.required, Validators.pattern(/^[^<>{}\[\]()\",;!|\\/?^&%$£:#*]+$/)]),
      sesso: new FormControl<string|null>(null, Validators.required),
      dataNascita: new FormControl<Date|null>(null, Validators.required),
      alias: new FormControl<string|null>(null, Validators.pattern(/^[^<>{}\[\]()\",;!|\\/?^&%$£:#*]+$/)),
      sessoAlias: new FormControl<string|null>(null),
      luogoNascita: new FormControl<string|null>(null, [Validators.required, Validators.pattern(/^[^<>{}\[\]\";!|\\/?^&%$£:#*]+$/)]),
      provinciaNascita: new FormControl<Provincia|null>(null, [Validators.required, this.customProvinciaValidators()]),
      cittadinanza: new FormControl<Nazione|null>(null, [Validators.required, this.customNazioneValidators('cittadinanza')]),
      permessoSoggiorno: new FormControl<boolean|null>(false),
      permessoSoggiornoScadenza: new FormControl<Date|null>(null),
      permessoSoggiornoIllimitato: new FormControl<boolean|null>(false),

      residenzaIndirizzo: new FormControl<string|null>(null, Validators.pattern(/^[^<>{}\[\]()\";!|?^&%$£:#*]+$/)),
      residenzaCap: new FormControl<string|null>(null),
      residenzaComune: new FormControl<Comune|null>(null, this.customComuneValidators()),
      residenzaProvincia: new FormControl<Provincia|null>(null, this.customProvinciaValidators()),
      residenzaStato: new FormControl<Nazione|null>(null, this.customNazioneValidators('stato')),
      residenzaLuogo: new FormControl<string|null>(null, Validators.pattern(/^[^<>{}\[\]\";!|\\/?^&%$£:#*]+$/)),

      domicilioIndirizzo: new FormControl<string|null>(null, Validators.pattern(/^[^<>{}\[\]()\";!|?^&%$£:#*]+$/)),
      domicilioCap: new FormControl<string|null>(null),
      domicilioComune: new FormControl<Comune|null>(null, this.customComuneValidators()),
      domicilioProvincia: new FormControl<Provincia|null>(null, this.customProvinciaValidators()),
      domicilioLuogo: new FormControl<string|null>(null, Validators.pattern(/^[^<>{}\[\]\";!|\\/?^&%$£:#*]+$/)),

      email: new FormControl<string|null>(null, [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]),
      pec: new FormControl<string|null>(null, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)),
      telefonoPrincipale: new FormControl<string|null>(null, Validators.pattern(/^[0-9]+$/)),
      prefissoTelefonoPrincipale: new FormControl<Prefisso|null>(null, this.customPrefissoValidators()),
      idTelefonoPrincipale: new FormControl<number|null>(null),
    }),
    albo: new FormGroup({
      statoIscritto: new FormControl<StatoIscritto|null>(null, Validators.required),
      numeroIscrizione: new FormControl<number|null>(null),
      dataIscrizione: new FormControl<Date|null>(null),
      sezioneAlbo: new FormControl<string|null>(null, Validators.required),
      domandaProtocollo: new FormControl<string|null>(null),
      domandaData: new FormControl<Date|null>(null),

      trasferimentoDaOrdine: new FormControl<Ordine|null>(null, this.customOrdineValidators()),
      trasferimentoEntrataData: new FormControl<Date|null>(null),
      trasferimentoAOrdine: new FormControl<Ordine|null>(null, this.customOrdineValidators()),
      trasferimentoUscitaData: new FormControl<Date|null>(null),
      sospensioneDal: new FormControl<Date|null>(null),
      sospensioneAl: new FormControl<Date|null>(null),
      motivoSospensione: new FormControl<Articolo26|null>(null),
      procedimentoDisciplinare: new FormControl<GruppoValore|null>(null),
      cancellatoData: new FormControl<Date|null>(null),
      motivoCancellazione: new FormControl<MotivoCancellazione|null>(null),
      radiatoData: new FormControl<Date|null>(null),

      ctu: new FormControl<CTU|null>(null, this.customCTUValidators()),
      perito: new FormControl<CTU|null>(null, this.customCTUValidators()),
      articolo82: new FormControl<boolean|null>(null),
      dipendentePubblico: new FormControl<boolean|null>(null),
      professoreUniversitario: new FormControl<boolean|null>(null),
      professoreUniversita: new FormControl<Universita|null>(null)
    }),
    titoli: new FormGroup({
      titolo: new FormControl<Titolo|null>(null, this.customTitoloValidators()),
      laureaUniversita: new FormControl<Universita|null>(null),
      laureaData: new FormControl<Date|null>(null),
      laureaAbilitante: new FormControl<boolean|null>(null),

      abilitazione: new FormControl<Abilitazione|null>(null),
      abilitazioneUniversita: new FormControl<Universita|null>(null),
      abilitazioneData: new FormControl<string|null>(null, Validators.pattern(/^[^<>{}\[\]()\",;!|?^&%$£:#*]+$/)),
      abilitazioneRiserva: new FormControl<boolean|null>(null),

      psicoterapeuta: new FormControl<boolean|null>(null),
      psicoterapeutaOption: new FormControl<Psicoterapeuta|null>(null),
      psicoterapeutaData: new FormControl<Date|null>(null),
      neuropsicologo: new FormControl<boolean|null>(null),
      neuropsicologoProtocollo: new FormControl<string|null>(null, Validators.pattern(/^[^<>{}\[\]()\",;!|\\/?^&%$£:#*]+$/)),
      neuropsicologoProtocolloData: new FormControl<Date|null>(null),

      controlloCasellario: new FormControl<boolean|null>(null),
      controlloLaurea: new FormControl<boolean|null>(null),
      controlloAbilitazione: new FormControl<boolean|null>(null)
    })
  });

  @ViewChild('tv') tabview?: TabView;

  updating: boolean = false;

  ngOnInit(): void {

    //caricamento iscritto on routing
    const dataIscritto = this.route.snapshot.data;

    if(dataIscritto['nuovoIscritto']){
      this.ultimoNumeroIscrizione = dataIscritto['ultimoNumeroIscrizione'];
    }

    this.popolaDropdown(dataIscritto['iscrittoDropdown'], dataIscritto['iscritto']);
    this.loadIscritto(dataIscritto['iscritto'], dataIscritto['nuovoIscritto'], dataIscritto['quote']);
    
    if(dataIscritto['cronologie']){
      this.sospensioni = dataIscritto['cronologie'].sospensioni;
      this.altreIscrizioni = dataIscritto['cronologie'].altreIscrizioni && [1,2,3].includes(dataIscritto['iscritto'].statoIscritto.id);
    }

    this.iscrittoForm.get('anagrafica.codiceFiscale')?.valueChanges.subscribe((cf) => {
      this.checkCodiceFiscaleEsistente(cf!);
    })
    this.iscrittoForm.get('anagrafica.alias')?.valueChanges.subscribe((value) => {
      const sessoAlias = this.iscrittoForm.get('anagrafica.sessoAlias');
      if(value && value.trim() != ''){
        sessoAlias?.enable();
      }
      else{
        sessoAlias?.disable();
        sessoAlias?.setValue(null);
      }
    })
    const permessoSoggiorno = this.iscrittoForm.get('anagrafica.permessoSoggiorno');
    const permessoSoggiornoIllimitato = this.iscrittoForm.get('anagrafica.permessoSoggiornoIllimitato');
    const permessoSoggiornoScadenza = this.iscrittoForm.get('anagrafica.permessoSoggiornoScadenza');
    permessoSoggiorno?.valueChanges.subscribe((value) => {
      if(value){
        permessoSoggiornoIllimitato?.setValue(false, {emitEvent: false});
        permessoSoggiornoScadenza?.enable();
        permessoSoggiornoScadenza?.setValidators(Validators.required);
        permessoSoggiornoScadenza?.markAsTouched();
        permessoSoggiornoScadenza?.markAsDirty();
        permessoSoggiornoScadenza?.updateValueAndValidity();
      }
      else{
        permessoSoggiornoScadenza?.disable();
        permessoSoggiornoScadenza?.setValue(null);
        permessoSoggiornoScadenza?.clearValidators();
      }
    })
    permessoSoggiornoIllimitato?.valueChanges.subscribe((value) => {
      if(value){
        permessoSoggiorno?.setValue(false, {emitEvent: false});
        permessoSoggiornoScadenza?.disable();
        permessoSoggiornoScadenza?.setValue(null);
      }
    })
    this.iscrittoForm.get('titoli.psicoterapeuta')?.valueChanges.subscribe((value) => {
      const psicoterapeutaOption = this.iscrittoForm.get('titoli.psicoterapeutaOption');
      const psicoterapeutaData = this.iscrittoForm.get('titoli.psicoterapeutaData');
      if(value){
        psicoterapeutaOption?.enable();
        psicoterapeutaData?.enable();
      }
      else{
        psicoterapeutaOption?.disable();
        psicoterapeutaOption?.setValue(null);
        psicoterapeutaData?.disable();
        psicoterapeutaData?.setValue(null);
      }
    })
    this.iscrittoForm.get('titoli.neuropsicologo')?.valueChanges.subscribe((value) => {
      const neuropsicologoProtocollo = this.iscrittoForm.get('titoli.neuropsicologoProtocollo');
      const neuropsicologoProtocolloData = this.iscrittoForm.get('titoli.neuropsicologoProtocolloData');
      if(value){
        neuropsicologoProtocollo?.enable();
        neuropsicologoProtocolloData?.enable();
      }
      else{
        neuropsicologoProtocollo?.disable();
        neuropsicologoProtocollo?.setValue(null);
        neuropsicologoProtocolloData?.disable();
        neuropsicologoProtocolloData?.setValue(null);
      }
    })
    this.iscrittoForm.get('albo.professoreUniversitario')?.valueChanges.subscribe((value) => {
      const professoreUniversita = this.iscrittoForm.get('albo.professoreUniversita');
      if(value){
        professoreUniversita?.enable();
      }
      else{
        professoreUniversita?.disable();
        professoreUniversita?.setValue(null);
      }
    })
    const trasferimentoEntrataData = this.iscrittoForm.get('albo.trasferimentoEntrataData');
    this.iscrittoForm.get('albo.trasferimentoDaOrdine')?.valueChanges.subscribe((value) => {
      if(value){
        trasferimentoEntrataData?.enable();
      }
      else{
        trasferimentoEntrataData?.disable();
        trasferimentoEntrataData?.setValue(null);
      }
    })
    this.iscrittoForm.get('albo.trasferimentoEntrataData')?.disable();
  }

  unsavedChecker(): Promise<void>{

    if(this.confrontaDatiOriginali()){
      return Promise.resolve();
    }

    return this.unsaved_service.unsavedChangesChecker(this.iscrittoForm);
  }

  //assegna valori al form
  loadIscritto(iscritto: Iscrizione, routeIscritto: boolean, quote: Quota[]){
    this.iscrittoForm.get('albo.numeroIscrizione')?.disable();
    if(!(iscritto && iscritto.statoIscritto && iscritto.statoIscritto.id == 6 && iscritto.delibera == null)){
      this.iscrittoForm.get('albo.sezioneAlbo')?.disable();
    }

    this.nuovoIscritto = routeIscritto;
    this.nuovoProvvisorio = this.route.snapshot.data['provvisorio'];

    //se nuovo iscritto
    if(routeIscritto){

      this.iscrittoForm.disable();
      this.iscrittoForm.get('anagrafica.codiceFiscale')?.enable();
      this.iscrittoForm.get('albo.statoIscritto')?.setValue(this.nuovoProvvisorio ? this.stato_provvisorio : this.stati[0]);

      this.statoIscrittoReadonly = false;

      this.iscrittoForm.get('albo.dataIscrizione')?.setValidators(Validators.required);
      if(this.nuovoProvvisorio){
        this.iscrittoForm.get('albo.dataIscrizione')?.disable();
      }

    }

    //se iscritto dettaglio
    if(iscritto && !routeIscritto){

      if(iscritto.statoIscritto.codiceCnop === 'P'){
        this.iscrittoForm.get('albo.dataIscrizione')?.disable();
      }

      this.annotazioni = iscritto.annotazioni;

      //this.urlFototesseraUpload = `${base_url}/images/upload/fototessera/${iscritto.id.toString()}`;

      this.currentId = iscritto.id;
      this.anagraficaId = iscritto.anagrafica.id;
      this.infoOriginali = iscritto;
      this.quoteOriginali = quote;

      this.listaData.lista = quote;
      this.listaData.id = iscritto.id;

      this.selectedStato = iscritto.statoIscritto;

      this.caricaImmagineIscritto();

      if(iscritto.statoIscritto === null){
        this.iscrittoForm.get('anagrafica.statoIscritto')?.clearValidators();
        this.iscrittoForm.get('anagrafica.statoIscritto')?.updateValueAndValidity();
      }

      const numeroPrincipaleEstratto = this.estraiNumeroPrincipale(iscritto.anagrafica.telefoni);
      this.listaNumeriSecondari = this.estraiNumeriSecondari(iscritto.anagrafica.telefoni);

      if(iscritto.sospensioneDal !== null) this.iscrittoForm.get('albo.sospensioneAl')?.enable();

      if(numeroPrincipaleEstratto !== null) this.selectedPrefisso = numeroPrincipaleEstratto.prefisso;
      
      this.iscrittoForm.patchValue({
        anagrafica: {
          codiceFiscale: (iscritto.anagrafica.codiceFiscale) ? iscritto.anagrafica.codiceFiscale.toUpperCase() : '',
          alias: iscritto.anagrafica.alias,
          sessoAlias: iscritto.anagrafica.sessoAlias,
          nome: this.gestisciMaiuscole(iscritto.anagrafica.nome),
          cognome: this.gestisciMaiuscole(iscritto.anagrafica.cognome),
          sesso: iscritto.anagrafica.sesso,
          luogoNascita: iscritto.anagrafica.luogoNascita,
          provinciaNascita: iscritto.anagrafica.provinciaNascita,
          dataNascita: iscritto.anagrafica.dataNascita ? new Date(iscritto.anagrafica.dataNascita) : null,
          cittadinanza: iscritto.anagrafica.cittadinanza,
          permessoSoggiorno: iscritto.anagrafica.permessoSoggiorno,
          permessoSoggiornoScadenza: iscritto.anagrafica.permessoSoggiornoScadenza ? new Date(iscritto.anagrafica.permessoSoggiornoScadenza) : null,
          permessoSoggiornoIllimitato: iscritto.anagrafica.permessoSoggiornoIllimitato,
          email: (iscritto.anagrafica.email) ? iscritto.anagrafica.email.toLowerCase() : '',
          pec: (iscritto.anagrafica.pec) ? iscritto.anagrafica.pec.toLowerCase() : '',

          telefonoPrincipale: numeroPrincipaleEstratto?.numero,
          prefissoTelefonoPrincipale: numeroPrincipaleEstratto?.prefisso ? numeroPrincipaleEstratto?.prefisso : null,
          idTelefonoPrincipale: numeroPrincipaleEstratto?.id,

          residenzaIndirizzo: iscritto.anagrafica.residenzaIndirizzo,
          residenzaCap: iscritto.anagrafica.residenzaCap,
          residenzaComune: iscritto.anagrafica.residenzaComune,
          residenzaProvincia: iscritto.anagrafica.residenzaProvincia,
          residenzaStato: iscritto.anagrafica.residenzaStato,
          residenzaLuogo: iscritto.anagrafica.residenzaLuogo,

          domicilioIndirizzo: iscritto.anagrafica.domicilioIndirizzo,
          domicilioCap: iscritto.anagrafica.domicilioCap,
          domicilioComune: iscritto.anagrafica.domicilioComune,
          domicilioProvincia: iscritto.anagrafica.domicilioProvincia,
          domicilioLuogo: iscritto.anagrafica.domicilioLuogo
        },
        albo: {
          statoIscritto: iscritto.statoIscritto,
          numeroIscrizione: iscritto.numeroIscrizione,
          dataIscrizione: iscritto.dataIscrizione ? new Date(iscritto.dataIscrizione) : null,
          sezioneAlbo: iscritto.sezioneAlbo,
          domandaProtocollo: iscritto.domandaProtocollo,
          domandaData: iscritto.domandaData ? new Date(iscritto.domandaData) : null,

          trasferimentoDaOrdine: iscritto.trasferimentoDaOrdine,
          trasferimentoEntrataData: iscritto.trasferimentoEntrataData ? new Date(iscritto.trasferimentoEntrataData) : null,
          trasferimentoAOrdine: iscritto.trasferimentoAOrdine,
          trasferimentoUscitaData: iscritto.trasferimentoUscitaData ? new Date(iscritto.trasferimentoUscitaData) : null,
          sospensioneDal: iscritto.sospensioneDal ? new Date(iscritto.sospensioneDal) : null,
          sospensioneAl: iscritto.sospensioneAl ? new Date(iscritto.sospensioneAl) : null,
          motivoSospensione: iscritto.motivoSospensione,
          procedimentoDisciplinare: this.statoProcedimento.find(stato => stato.valore === iscritto.procedimentoDisciplinare),
          cancellatoData: iscritto.cancellatoData ? new Date(iscritto.cancellatoData) : null,
          motivoCancellazione: iscritto.motivoCancellazione ? this.motivoCancellazioneOptions.find(item => item.id == iscritto.motivoCancellazione.id) : null,
          radiatoData: iscritto.radiatoData ? new Date(iscritto.radiatoData) : null,

          ctu: iscritto.ctu,
          perito: iscritto.perito,
          dipendentePubblico: iscritto.dipendentePubblico,
          articolo82: iscritto.articolo82,
          professoreUniversitario: iscritto.professoreUniversitario,
          professoreUniversita: iscritto.professoreUniversita
        },
        titoli: {
          titolo: iscritto.titolo,
          abilitazione: iscritto.abilitazione,
          laureaUniversita: iscritto.laureaUniversita,
          laureaData: iscritto.laureaData ? new Date(iscritto.laureaData) : null,

          laureaAbilitante: iscritto.laureaAbilitante,
          abilitazioneUniversita: iscritto.abilitazioneUniversita,
          abilitazioneData: iscritto.abilitazioneData,
          abilitazioneRiserva: iscritto.abilitazioneRiserva,

          psicoterapeuta: iscritto.psicoterapeuta,
          psicoterapeutaOption: iscritto.psicoterapeutaOption,
          psicoterapeutaData: iscritto.psicoterapeutaData ? new Date(iscritto.psicoterapeutaData) : null,
          neuropsicologo: iscritto.neuropsicologo,
          neuropsicologoProtocollo: iscritto.neuropsicologoProtocollo,
          neuropsicologoProtocolloData: iscritto.neuropsicologoProtocolloData ? new Date(iscritto.neuropsicologoProtocolloData) : null,

          controlloCasellario: iscritto.controlloCasellario,
          controlloLaurea: iscritto.controlloLaurea,
          controlloAbilitazione: iscritto.controlloAbilitazione
        }
      });

      if(this.iscrittoForm.get('anagrafica.alias')?.value){
        this.iscrittoForm.get('anagrafica.sessoAlias')?.enable();
      }
      else{
        this.iscrittoForm.get('anagrafica.sessoAlias')?.disable();
      }

      if(this.iscrittoForm.get('anagrafica.permessoSoggiorno')?.value){
        this.iscrittoForm.get('anagrafica.permessoSoggiornoScadenza')?.enable();
        this.iscrittoForm.get('anagrafica.permessoSoggiornoScadenza')?.setValidators(Validators.required);
        this.iscrittoForm.get('anagrafica.permessoSoggiornoScadenza')?.updateValueAndValidity();
      }
      else{
        this.iscrittoForm.get('anagrafica.permessoSoggiornoScadenza')?.disable();
        this.iscrittoForm.get('anagrafica.permessoSoggiornoScadenza')?.clearValidators();
      }

      if(this.iscrittoForm.get('titoli.psicoterapeuta')?.value){
        this.iscrittoForm.get('titoli.psicoterapeutaOption')?.enable();
        this.iscrittoForm.get('titoli.psicoterapeutaData')?.enable();
      }
      else{
        this.iscrittoForm.get('titoli.psicoterapeutaOption')?.disable();
        this.iscrittoForm.get('titoli.psicoterapeutaData')?.disable();
      }

      if(this.iscrittoForm.get('titoli.neuropsicologo')?.value){
        this.iscrittoForm.get('titoli.neuropsicologoProtocollo')?.enable();
        this.iscrittoForm.get('titoli.neuropsicologoProtocolloData')?.enable();
      }
      else{
        this.iscrittoForm.get('titoli.neuropsicologoProtocollo')?.disable();
        this.iscrittoForm.get('titoli.neuropsicologoProtocolloData')?.disable();
      }

      if(this.iscrittoForm.get('albo.professoreUniversitario')?.value){
        this.iscrittoForm.get('albo.professoreUniversita')?.enable();
      }
      else{
        this.iscrittoForm.get('albo.professoreUniversita')?.disable();
      }

      if(this.iscrittoForm.get('albo.statoIscritto')?.value?.codiceCnop == 'S'){
        this.iscrittoForm.get('albo.sospensioneAl')?.disable();
      }

      this.dataConfrontoOriginale = this.creaOggetto(this.iscrittoForm);

    }

    if(!this.role_service.isAlboRole()){
      this.iscrittoForm.disable();
    }

  }

  trimStrings(value: any): any{
    if(typeof value === "string"){
      return value.trim();
    }
    if(Array.isArray(value)){
      return value.map(this.trimStrings);
    }
    if(value !== null && typeof value === "object"){
      Object.keys(value).forEach((key) => {
        value[key] = this.trimStrings(value[key]);
      });
      return value;
    }
    return value;
  }

  //invio dati nuovo iscritto - modifica dati
  inviaDatiIscritto(){
    const formValues = this.trimStrings(this.iscrittoForm.value);
    const numeriSecondari = this.listaNumeriSecondari;

    const data = {
      anagrafica: {
        id: (this.nuovoIscritto && this.anagraficaId == null) ? null : this.anagraficaId,

        codiceFiscale: formValues.anagrafica?.codiceFiscale?.toUpperCase(),
        nome: this.gestisciMaiuscole(formValues.anagrafica?.nome),
        cognome: this.gestisciMaiuscole(formValues.anagrafica?.cognome),
        sesso: formValues.anagrafica?.sesso,
        dataNascita: formValues.anagrafica?.dataNascita ? this.buildDate(formValues.anagrafica?.dataNascita) : null,
        alias: formValues.anagrafica?.alias,
        sessoAlias: formValues.anagrafica?.sessoAlias,
        luogoNascita: formValues.anagrafica?.luogoNascita,
        provinciaNascita: formValues.anagrafica?.provinciaNascita,
        cittadinanza: (formValues.anagrafica?.cittadinanza) ? formValues.anagrafica?.cittadinanza : null,
        permessoSoggiorno: formValues.anagrafica?.permessoSoggiorno ?? false,
        permessoSoggiornoScadenza: formValues.anagrafica?.permessoSoggiornoScadenza ? this.buildDate(formValues.anagrafica?.permessoSoggiornoScadenza) : null,
        permessoSoggiornoIllimitato: formValues.anagrafica?.permessoSoggiornoIllimitato ?? false,

        residenzaIndirizzo: formValues.anagrafica?.residenzaIndirizzo,
        residenzaCap: formValues.anagrafica?.residenzaCap,
        residenzaComune: formValues.anagrafica?.residenzaComune,
        residenzaProvincia: formValues.anagrafica?.residenzaProvincia,
        residenzaStato: formValues.anagrafica?.residenzaStato,
        residenzaLuogo: formValues.anagrafica?.residenzaLuogo,

        domicilioIndirizzo: formValues.anagrafica?.domicilioIndirizzo,
        domicilioCap: formValues.anagrafica?.domicilioCap,
        domicilioComune: formValues.anagrafica?.domicilioComune,
        domicilioProvincia: formValues.anagrafica?.domicilioProvincia,
        domicilioLuogo: formValues.anagrafica?.domicilioLuogo,

        email: formValues.anagrafica?.email?.toLowerCase(),
        pec: formValues.anagrafica?.pec?.toLowerCase()
      },
      iscrizione: {
        id: (this.nuovoIscritto) ? null : this.currentId,

        statoIscritto: formValues.albo?.statoIscritto,
        numeroIscrizione: this.iscrittoForm.get('albo.numeroIscrizione')?.value,
        dataIscrizione: formValues.albo?.dataIscrizione ? this.buildDate(formValues.albo?.dataIscrizione) : null,
        sezioneAlbo: formValues.albo?.sezioneAlbo,
        domandaProtocollo: formValues.albo?.domandaProtocollo,
        domandaData: formValues.albo?.domandaData ? this.buildDate(formValues.albo?.domandaData) : null,

        titolo: formValues.titoli?.titolo,
        laureaUniversita: formValues.titoli?.laureaUniversita,
        laureaData: formValues.titoli?.laureaData ? this.buildDate(formValues.titoli?.laureaData) : null,
        laureaAbilitante: formValues.titoli?.laureaAbilitante ?? false,
        abilitazione: formValues.titoli?.abilitazione,
        abilitazioneUniversita: formValues.titoli?.abilitazioneUniversita,
        abilitazioneData: formValues.titoli?.abilitazioneData,
        abilitazioneRiserva: formValues.titoli?.abilitazioneRiserva ?? false,
        psicoterapeuta: formValues.titoli?.psicoterapeuta ?? false,
        psicoterapeutaOption: formValues.titoli?.psicoterapeutaOption,
        psicoterapeutaData: formValues.titoli?.psicoterapeutaData ? this.buildDate(formValues.titoli?.psicoterapeutaData) : null,
        neuropsicologo: formValues.titoli?.neuropsicologo ?? false,
        neuropsicologoProtocollo: formValues.titoli?.neuropsicologoProtocollo,
        neuropsicologoProtocolloData: formValues.titoli?.neuropsicologoProtocolloData ? this.buildDate(formValues.titoli?.neuropsicologoProtocolloData) : null,

        controlloCasellario: formValues.titoli?.controlloCasellario ?? false,
        controlloAbilitazione: formValues.titoli?.controlloAbilitazione ?? false,
        controlloLaurea: formValues.titoli?.controlloLaurea ?? false,

        ctu: formValues.albo?.ctu,
        perito: formValues.albo?.perito,
        articolo82: formValues.albo?.articolo82 ?? false,
        dipendentePubblico: formValues.albo?.dipendentePubblico ?? false,
        professoreUniversitario: formValues.albo?.professoreUniversitario ?? false,
        professoreUniversita: formValues.albo?.professoreUniversita,

        trasferimentoDaOrdine: formValues.albo?.trasferimentoDaOrdine ? formValues.albo?.trasferimentoDaOrdine : null,
        trasferimentoEntrataData: formValues.albo?.trasferimentoEntrataData ? this.buildDate(formValues.albo?.trasferimentoEntrataData) : null,
        trasferimentoAOrdine: formValues.albo?.trasferimentoAOrdine ? formValues.albo?.trasferimentoAOrdine : null,
        trasferimentoUscitaData: formValues.albo?.trasferimentoUscitaData ? this.buildDate(formValues.albo?.trasferimentoUscitaData) : null,
        sospensioneDal: formValues.albo?.sospensioneDal ? this.buildDate(formValues.albo?.sospensioneDal) : null,
        sospensioneAl: formValues.albo?.sospensioneAl ? this.buildDate(formValues.albo?.sospensioneAl) : null,
        motivoSospensione: formValues.albo?.motivoSospensione ? formValues.albo?.motivoSospensione : null,
        procedimentoDisciplinare: formValues.albo?.procedimentoDisciplinare?.valore,
        cancellatoData: formValues.albo?.cancellatoData ? this.buildDate(formValues.albo?.cancellatoData) : null,
        motivoCancellazione: formValues.albo?.motivoCancellazione ? formValues.albo?.motivoCancellazione : null,
        radiatoData: formValues.albo?.radiatoData ? this.buildDate(formValues.albo?.radiatoData) : null
      },
      telefoni: caricaTelefoni(),
      nuovoProvvisorio: this.nuovoProvvisorio
    };

    if(this.nuovoIscritto){
      this.inserisciNuovoIscritto(data)
    }else{
      this.modificaIscritto(data);
    }

    function caricaTelefoni(): Telefono[]{
      const telefoni: Telefono[] = [];
      const telefonoPrincipale: Telefono = {
        id: formValues.anagrafica?.idTelefonoPrincipale,
        prefisso: formValues.anagrafica?.prefissoTelefonoPrincipale!,
        numero: formValues.anagrafica?.telefonoPrincipale!,
        principale: true,
        descrizione: '',
        tipo: ''
      }
      telefoni.push(telefonoPrincipale);
      if(numeriSecondari.length > 0) {
        numeriSecondari.forEach(numeroSecondario => {
          if(numeroSecondario.numero) telefoni.push(numeroSecondario);
        });
      }
      return telefoni;
    }

  }

  //aggiunge numero alla lista
  aggiungiNumero(){
    this.ref = this.dialog_service.open(DialogDinamicoComponent, {
      data: {
        tipo: 'aggiungiTelefono'
      },
      header: this.translate.instant('gestioneAlbo.dettaglioIscritto.form.contatti.titoloDialog')
    });

    this.ref.onClose.subscribe({
      next: result => {
        if(result != undefined){
          if(result.elemento){

            const t = result.elemento;

            const data = {
              telefono: {
                prefisso: t.prefisso,
                numero: t.numero,
                tipo: t.tipo,
                descrizione: t.descrizione
              },
              id_iscritto: this.currentId
            }

            this.iscritti_service.creaTelefonoSecondario(data).subscribe({
              complete: () => {

                this.message_service.add({
                  severity: 'success',
                  summary: `Operazione completata`,
                  detail: `Il numero ${result.elemento.numero} è stato inserito`
                })
                setTimeout(() => {
                  this.iscritti_service.getIscritto(this.currentId.toLocaleString()).subscribe(result => {
                    this.loadIscritto(result, false, result.quoteList);
                  })
                }, 1000)
              },
              error: (error) => {
                if(error.status === 409){
                  this.message_service.add({ severity: 'error', summary: 'Numero già registrato', detail: 'Operazione interrotta.' })
                }

              }
            })

          }
        }

      }
    })

  }

  //eliminazione di un numero secondario
  eliminaNumero(telefono: Telefono){
    this.ref = this.dialog_service.open(DialogDinamicoComponent, {
      data: {
        tipo: 'eliminazioneTelefono',
        elemento: telefono
      },
      header: 'Eliminazione Numero'
    });

    this.ref.onClose.subscribe({
      next: result => {
        if(result != undefined){
          if(result.elemento){

            this.iscritti_service.cancellaTelefonoSecondario(result.elemento).subscribe({
              next: result => {},
              complete: () => {
                this.message_service.add({ severity: 'success', summary: `Operazione completata`, detail: `Il numero è stato cancellato` })
                setTimeout(() => {
                  this.iscritti_service.getIscritto(this.currentId.toLocaleString()).subscribe(result => {
                    this.loadIscritto(result, false, result.quoteList);
                  })
                }, 1000)
              },
              error: (error) => {
                this.message_service.add({ severity: 'error', summary: 'Operazione Annullata', detail: 'Qualcosa è andato storto.' })
              }
            })

          }
        }

      },
      error: (error) => {
        this.message_service.add({ severity: 'error', summary: 'Operazione Annullata', detail: 'Qualcosa è andato storto.' })
      }
    })

  }

  //gestione dialog cambio stato dell'iscritto
  modificaStato(){
    let dataStato: Date | undefined | null;
    const formValues = this.iscrittoForm.value;
    const statoIscrittoAttuale = formValues.albo?.statoIscritto;
    const trasferimentoA_attuale = formValues.albo?.trasferimentoAOrdine;

    if(statoIscrittoAttuale?.nome === 'TRASFERIMENTO') dataStato = formValues.albo?.trasferimentoUscitaData;
    if(statoIscrittoAttuale?.nome === 'SOSPESO') dataStato = formValues.albo?.sospensioneDal;
    if(statoIscrittoAttuale?.nome === 'RADIATO') dataStato = formValues.albo?.radiatoData;
    if(statoIscrittoAttuale?.nome === 'CANCELLATO') dataStato = formValues.albo?.cancellatoData;

    this.ref = this.dialog_service.open(DialogCambioStatoComponent, {
      data: {
        statoIscrittoAttuale: statoIscrittoAttuale,
        idIscritto: this.infoOriginali?.id,
        ordini: this.oridiniOptions.filter(item => item.nome !== environment.labelRegionale),
        motiviSospensione: this.articolo26Options,
        motiviCancellazione: this.motivoCancellazioneOptions
      },
      header: 'Seleziona stato iscritto'
    });

    this.ref.onClose.subscribe({
      next: result => {
        if(result != undefined){
          this.message_service.add({
            severity: 'success',
            summary: `Cambio Stato Completato`,
            detail: `Stato iscritto cambiato in: ${result.data.stato.nome}`
          })

          const si = result.data.stato;
          const day = result.data.data;
          const trasfA = result.data.trasferimentoA;

          this.iscrittoForm.get('albo.statoIscritto')?.patchValue(si);

          if(day){
            let str = '';
            if(si.nome === 'ATTIVO') str = 'albo.sospensioneAl';
            if(si.nome === 'SOSPESO'){
              str = 'albo.sospensioneDal';
              this.iscrittoForm.get('albo.sospensioneAl')?.patchValue(null);
            }
            if(si.nome === 'TRASFERIMENTO') str = 'albo.trasferimentoUscitaData';
            if(si.nome === 'CANCELLATO') str = 'albo.cancellatoData';
            if(si.nome === 'RADIATO') str = 'albo.radiatoData';

            this.iscrittoForm.get(str)?.patchValue(new Date(day));
          }
          if(trasfA){
            const ordineAttuale = this.oridiniOptions.find(item => item.nome == environment.labelRegionale)!;
            this.iscrittoForm.get('albo.trasferimentoAOrdine')?.patchValue(trasfA);
            this.iscrittoForm.get('albo.trasferimentoDaOrdine')?.patchValue(ordineAttuale);
          }

          this.iscritti_service.getIscritto(this.currentId).subscribe(result => {
            this.loadIscritto(result, false, result.quoteList);
          });
        }
      },
      error: (error) => {
        this.message_service.add({
          severity: 'error',
          summary: 'Operazione Annullata',
          detail: error.error
        })
      }
    })
  }

  //sincronizza iscritto con albo nazionale
  startSynch(id: number){
    this.syncSpinner = true;
    this.cnop_service.startSyncSingle(id.toString()).subscribe({
      next: () => {
        this.syncSpinner = false;
        this.message_service.add({
          severity: 'success',
          summary: `Sincronizzazione Completata`,
          detail: `Sincronizzazione con albo nazionale effettuata`
        })
      },
      error: () => {
        this.syncSpinner = false;
        this.message_service.add({
          severity: 'error',
          summary: 'Sincronizzazione Interrotta',
          detail: 'Qualcosa è andato storto.'
        })
      }
    })

  }

  //estrae il numero principale
  private estraiNumeroPrincipale(telefoni: Telefono[]): Telefono | null{
    let telefonoPrincipale: Telefono | null = null;
    telefoni.forEach(telefono => {
      if(telefono.principale) telefonoPrincipale = telefono;
    })
    return telefonoPrincipale;
  }

  //ignora il numero principale
  private estraiNumeriSecondari(telefoni: Telefono[]): Telefono[]{
    let telefoniSecondari: Telefono[] = [];
    telefoni.forEach(telefono => {
      if(!telefono.principale) telefoniSecondari.push(telefono);
    })
    return telefoniSecondari;
  }

  //inserisci nuovo iscritto nel database
  private inserisciNuovoIscritto(data: any){
    let id: number = 0;
    if(this.nuovoProvvisorio && !data.iscrizione.sezioneAlbo){
      data.iscrizione.sezioneAlbo = "A";
    }

    this.iscritti_service.inserisciIscritto(data).subscribe({
      next: result => {
        this.isLoadingSpinner = true;
        id = result.id;
        if(this.nuovoProvvisorio){
          this.message_service.add({
            severity: 'success',
            summary: `Operazione completata`,
            detail: 'Nuovo provvisorio generato correttamente'
          })
        }
        else{
          this.message_service.add({
            severity: 'success',
            summary: `Operazione completata`,
            detail: `Nuovo utente generato con numero iscrizione: ${result.numeroIscrizione}`
          })
        }
      },
      complete: () => {
        this.gestioneSpinner('Crea', '', id);
      },
      error: err => {
        console.log(err);
        this.gestioneSpinner('errore', err.error, 0);
      }
    });
  }

  //modifica iscritto
  private modificaIscritto(data: any){
    this.modificaInCorsoFlag = true;
    this.iscritti_service.modificaIscritto(this.currentId, data).subscribe({
      next: () => {
        this.isLoadingSpinner = true;
        this.gestioneSpinner('Modifica', '' , 0);
        let titoloPsudonimo = '';
        if(data.iscrizione.titolo){
          titoloPsudonimo = data.anagrafica.sesso == 'M' ? data.iscrizione.titolo.pseudonimoMaschile : data.iscrizione.titolo.pseudonimoFemminile;
        }
        data.iscrizione.statoIscritto.nome === 'PROVVISORIO' ?
          this.shared_service.changeMessage(`${data.anagrafica.nome} ${data.anagrafica.cognome}` + (data.iscrizione.titolo ? ` ${titoloPsudonimo}` : ``)) :
          this.shared_service.changeMessage(`${data.anagrafica.nome} ${data.anagrafica.cognome} n.${data.iscrizione.numeroIscrizione}` + (data.iscrizione.titolo ? ` ${titoloPsudonimo}` : ``));
      },
      error: err => {
        this.gestioneSpinner('errore', err.error, 0);
      }
    });
  }

  //gestione spinner bottone
  private gestioneSpinner(evento: string, error: string, id: number){

    if(evento === 'errore'){
      this.message_service.add({ severity: 'error', summary: 'Operazione interrotta', detail: error });

      const values = this.iscrittoForm.value;

      if(values.anagrafica?.permessoSoggiorno && values.anagrafica.permessoSoggiornoIllimitato){
        this.flagSoggiorno = true;
        this.flagSoggiornoIllimitato = true;
        this.flagScadenzaSoggiorno = false;
      }

      if(values.anagrafica?.permessoSoggiorno && values.anagrafica.permessoSoggiornoScadenza === null && !values.anagrafica.permessoSoggiornoIllimitato){
        this.flagSoggiorno = false;
        this.flagSoggiornoIllimitato = false;
        this.flagScadenzaSoggiorno = true;
      }

      if(!values.anagrafica?.permessoSoggiorno && values.anagrafica?.permessoSoggiornoScadenza && !values.anagrafica.permessoSoggiornoIllimitato){
        this.flagSoggiorno = true;
        this.flagSoggiornoIllimitato = false;
        this.flagScadenzaSoggiorno = false;
      }

    }

    this.isLoadingSpinner = false;

    if(evento === 'Modifica'){
      this.message_service.add({
        severity: 'success',
        summary: 'Modifica completata',
        detail: 'Iscritto Modificato correttamente'
      });
      this.iscritti_service.getIscritto(this.currentId).subscribe(result => {
        this.iscrittoForm.get('albo.sospensioneAl')?.disable();
        this.loadIscritto(result, false, result.quoteList);
      });
    }

    if(evento === 'Crea'){
      this.router.navigate(
        [`/gestione_albo/gestione_iscritti/dettaglio_iscritto/${id}`]
      );
    }

    if(evento !== 'errore'){
      this.flagSoggiorno = false;
      this.flagSoggiornoIllimitato = false;
      this.flagScadenzaSoggiorno = false;
      this.iscrittoForm.markAsUntouched();
      this.iscrittoForm.markAsPristine();
    }
  }

  //validator personalizzato per lunghezza
  private customLenghtValidator(length: number){
    return (control: any) => {
      if (control.value && control.value.length !== length) {
        return { 'invalidLength': true };
      }
      return null;
    };
  }

  //prima lettera maiuscola
  private gestisciMaiuscole(stringa: string | null | undefined){

    if(stringa === null || stringa === undefined) return null;

    return stringa.split(" ").map(parola => primaMaiuscola(parola)).join(" ");

    function primaMaiuscola(parola: string): string{
      return parola.charAt(0).toUpperCase() + parola.slice(1);
    }
  }

  //popola i dropdown
  private popolaDropdown(dropdownOptions: IscrittoDropdownDto, iscritto: Iscrizione){

    this.regioniOptions = dropdownOptions.regioniList;
    this.nazioni = dropdownOptions.nazioneList;
    this.province = dropdownOptions.provinciaList.map(provincia => ({ ...provincia, disabled: !provincia.flag_attiva }));
    this.comuni = dropdownOptions.comuneList.map(comune => ({ ...comune, disabled: !comune.flag_attivo }));
    this.articolo26Options = dropdownOptions.articolo26List;
    this.CTUOptions = dropdownOptions.CTUList;
    this.abilitazioneOptions = dropdownOptions.abilitazioneList;
    this.psicoterapeutaOptions = dropdownOptions.psicoterapeutaList;
    this.titoloOptions = dropdownOptions.titoloList;
    this.universitaOptions = dropdownOptions.universitaList;
    this.prefissoOptions = dropdownOptions.prefissoList;
    this.oridiniOptions = iscritto && iscritto.statoIscritto.codiceCnop === 'P'
      ? dropdownOptions.ordiniList.filter(item => item.nome !== environment.labelRegionale)
      : dropdownOptions.ordiniList;
    this.oridineAttuale = dropdownOptions.ordiniList.find(item => item.nome === environment.labelRegionale);
    this.motivoCancellazioneOptions = dropdownOptions.motivoCancellazione;

    //articolo
    if(iscritto && iscritto.motivoSospensione){
      let flag = false
      for(const articolo of this.articolo26Options){
        if(iscritto.motivoSospensione.id === articolo.id){
          flag = true;
           break;
        }
      }

      if(!flag) this.articolo26Options.push(iscritto.motivoSospensione);
    }

    //ctu
    if(iscritto && iscritto.ctu){
      let flag = false
      for(const ctu of this.CTUOptions){
        if(iscritto.ctu){
          if(iscritto.ctu.id === ctu.id){
            flag = true;
            break;
          }
        }

      }

      if(!flag) this.CTUOptions.push(iscritto.ctu);
    }

    //specializzazione
    if(iscritto && iscritto.abilitazione){
      let flag = false
      for(const abilitazione of this.abilitazioneOptions){
        if(iscritto.abilitazione.id === abilitazione.id){
          flag = true;
          break;
        }
      }

      if(!flag) this.abilitazioneOptions.push(iscritto.abilitazione);
    }

    //titolo
    if(iscritto && iscritto.titolo){
      let flag = false
      for(const titolo of this.titoloOptions){
        if(iscritto.titolo.id === titolo.id){
          flag = true;
          break;
        }
      }

      if(!flag) this.titoloOptions.push(iscritto.titolo);
    }

    //universita
    if(iscritto && iscritto.abilitazioneUniversita){
      let flag = false;
      for(const universita of this.universitaOptions){
        if(iscritto.abilitazioneUniversita.id === universita.id){
          flag = true;
          break;
        }
      }

      if(!flag) this.universitaOptions.push(iscritto.abilitazioneUniversita);
    }

  }

  //autocompletamento per i p-autocomplete
  filterAutoComplete(event: AutoCompleteCompleteEvent, tipo: string){
    const query = event.query.toLowerCase();
    const queryParts = query.split(" ");

    if(tipo === 'comuni'){
      this.filteredComuni = this.comuni.filter(comune =>
        queryParts.every(part =>
            comune.nome.toLowerCase().includes(part)
        )
      );
    }

    if(tipo === 'province'){
      this.filteredProvince = this.province.filter(provincia =>
        queryParts.every(part =>
            provincia.nome.toLowerCase().includes(part)
        )
      );
    }

    if(tipo === 'nazioni'){
      this.filteredNazione = this.nazioni.filter(nazione =>
        queryParts.every(part =>
            nazione.nome.toLowerCase().includes(part)
        )
      );
    }

    if(tipo === 'cittadinanza'){
      this.filteredNazione = this.nazioni.filter(nazione =>
        queryParts.every(part =>
            nazione.nazionalita.toLowerCase().includes(part)
        )
      );
    }

    if(tipo === 'prefisso'){
      this.filteredPrefisso = this.prefissoOptions.filter(prefisso =>
        queryParts.every(part =>
          prefisso.nazione.toLowerCase().includes(part) || prefisso.codice.toLowerCase().includes(part)
        )
      );
    }

    if(tipo === 'universita'){
      this.filteredUniversita = this.universitaOptions.filter(univ =>
        queryParts.every(part =>
            univ.nome.toLowerCase().includes(part)
        )
      );
    }

    if(tipo === 'ctu'){
      this.filteredCTU = this.CTUOptions.filter(ctu =>
        queryParts.every(part =>
            ctu.nome.toLowerCase().includes(part)
        )
      );
    }

    if(tipo === 'ordini'){
      this.filteredOrdini = this.oridiniOptions.filter(ordine =>
        queryParts.every(part =>
            ordine.nome.toLowerCase().includes(part)
        )
      );
    }

  }

  //Validator per gli autocomplete
  customComuneValidators(){
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const corrisponde = this.comuni.some(c => c.nome === control.value.nome);
      return corrisponde ? null : { notValid: true };
    }
  }
  customProvinciaValidators(){
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const corrisponde = this.province.some(p => p.nome === control.value.nome);
      return corrisponde ? null : { notValid: true };
    }
  }
  customNazioneValidators(tipo: string){
    if(tipo === 'cittadinanza'){
      return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
          return null;
        }
        const corrisponde = this.nazioni.some(n => n.nazionalita === control.value.nazionalita);
        return corrisponde ? null : { notValid: true };
      }
    }
    else{
      return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
          return null;
        }
        const corrisponde = this.nazioni.some(n => n.nome === control.value.nome);
        return corrisponde ? null : { notValid: true };
      }
    }
  }
  customPrefissoValidators(){
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const corrisponde = this.prefissoOptions.some(pD => pD.codice === control.value.codice);
      return corrisponde ? null : { notValid: true };
    }
  }
  customTitoloValidators(){
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const corrisponde = this.titoloOptions.some(tD => tD.nome === control.value.nome);
      return corrisponde ? null : { notValid: true };
    }
  }
  customCTUValidators(){
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const corrisponde = this.CTUOptions.some(cD => cD.nome === control.value.nome);
      return corrisponde ? null : { notValid: true };
    }
  }
  customOrdineValidators(){
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const corrisponde = this.oridiniOptions.some(oD => oD.nome === control.value.nome);
      return corrisponde ? null : { notValid: true };
    }
  }

  caricaImmagineIscritto(){
    this.iscritti_service.getImmagineIscritto(this.anagraficaId!).subscribe({
      next: imageBlob => {
        this.immagineIscritto = URL.createObjectURL(imageBlob);
        this.caricaVociStampa(true);
      },
      error: e => {
        this.immagineIscritto = 'assets/images/default_user.jpg';
        this.caricaVociStampa(false);
      }
    });
  }

  onBasicSelect(event: FileSelectEvent){
    const fileCaricato = event.files[0];
    this.fototessera = {
      id: undefined,
      fileType: fileCaricato.type,
      fileSize: fileCaricato.size,
      fileData: fileCaricato
    };
  }

  cambiaFoto(){
    this.cambioFotoDialog = true;
  }
  uploadImageFile(){
    this.iscritti_service.caricaFototessera(this.anagraficaId!, this.getFileFototessera()).subscribe({
      next: (result: string) => {
        this.cambioFotoDialog = false;
        this.message_service.add({ severity: 'success', summary: 'Processo Completato', detail: result });
      },
      complete: () => {
        this.iscritti_service.getImmagineIscritto(this.anagraficaId!).subscribe({
          next: imageBlob => {
            this.immagineIscritto = URL.createObjectURL(imageBlob);
          },
          error: e => {
            this.immagineIscritto = 'assets/images/default_user.jpg';
          }
        });
      },
      error: e => {
        this.message_service.add({ severity: 'error', summary: 'Caricamento Interrotto', detail: e.error });
      }
    });
  }
  getFileFototessera(){
    const formData = new FormData();
    formData.append('file', this.fototessera!.fileData!);
    formData.append('fileSize', this.fototessera!.fileSize.toString());
    formData.append('mimeType', this.fototessera!.fileType);
    return formData;
  }

  disableBottoneSalva(): boolean{
    if(this.iscrittoForm.pristine || this.iscrittoForm.invalid || this.confrontaDatiOriginali() || this.codiceFiscaleFlag){
      return true;
    }

    return false;
  }

  disableBottoneSync(): boolean{
    if(this.isLoadingSpinner || !this.confrontaDatiOriginali()){
      return true;
    }

    return false;
  }

  creaOggetto(formGroup: FormGroup): any {
    const result: any = {};
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control instanceof FormGroup) {
        result[key] = this.creaOggetto(control);
      } else if (control instanceof FormControl) {
        result[key] = control.value;
      }
    });
    return result;
  }

  getStatoProcedimento(stato: string){
    return (stato != null && stato != '') ? this.statoProcedimento.find(p => p.valore == stato)!.nome : null
  }

  confrontaDatiOriginali(){

    const oggettoForm = this.creaOggetto(this.iscrittoForm);

    return areObjectsEqual(oggettoForm, this.dataConfrontoOriginale);

    function areObjectsEqual(obj1: any, obj2: any): boolean {
      // Check if both are objects
      if (typeof obj1 !== 'object' || typeof obj2 !== 'object' || obj1 === null || obj2 === null) {
        return obj1 === obj2;
      }

      // Check if both have the same keys
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);
      if (keys1.length !== keys2.length) {
        return false;
      }

      // Compare each key's value
      for (const key of keys1) {
        if (!keys2.includes(key)) {
          return false;
        }

        const val1 = obj1[key];
        const val2 = obj2[key];

        // Check if both are Date objects
        if (val1 instanceof Date && val2 instanceof Date) {
          if (val1.getTime() !== val2.getTime()) {
            return false;
          }
        // Recursively compare nested objects
        } else if (typeof val1 === 'object' && typeof val2 === 'object') {
          if (!areObjectsEqual(val1, val2)) {
            return false;
          }
        } else if (val1 !== val2) {
          return false;
        }
      }

      return true; //i dati sono uguali all'originale
    }

  }

  checkCodiceFiscaleEsistente(codiceFiscale: string){
    this.codiceFiscaleFlag = false;
    if(codiceFiscale?.length === 16){
      if(this.nuovoIscritto || (!this.nuovoIscritto && this.infoOriginali?.anagrafica.codiceFiscale !== codiceFiscale && !this.modificaInCorsoFlag)){
        this.iscritti_service.checkCodiceFiscale(codiceFiscale, this.nuovoProvvisorio == true).subscribe({
          next: (response: AnagraficaResponseDto) => {
            this.iscrittoForm.enable({emitEvent: false});
            this.iscrittoForm.get('anagrafica.sessoAlias')?.disable({emitEvent: false});
            this.iscrittoForm.get('anagrafica.permessoSoggiornoScadenza')?.disable({emitEvent: false});
            this.iscrittoForm.get('albo.trasferimentoEntrataData')?.disable({emitEvent: false});
            this.iscrittoForm.get('titoli.psicoterapeutaOption')?.disable({emitEvent: false});
            this.iscrittoForm.get('titoli.psicoterapeutaData')?.disable({emitEvent: false});
            this.iscrittoForm.get('titoli.neuropsicologoProtocollo')?.disable({emitEvent: false});
            this.iscrittoForm.get('titoli.neuropsicologoProtocolloData')?.disable({emitEvent: false});
            this.iscrittoForm.get('albo.professoreUniversita')?.disable({emitEvent: false});
            if(this.nuovoProvvisorio){
              this.iscrittoForm.get('albo.dataIscrizione')?.disable({emitEvent: false});
            }
            if(response){
              if(this.nuovoProvvisorio){
                this.iscrittoForm.get('albo.sezioneAlbo')?.disable({emitEvent: false});
                this.iscrittoForm.get('albo.sezioneAlbo')?.setValue("A", {emitEvent: false});
              }
              this.anagraficaId = response.anagrafica.id;
              this.loadAnagrafica(response.anagrafica);
              this.message_service.add({
                severity: 'warn',
                summary: 'Codice Fiscale Esistente',
                detail: response.messaggio
              });
            }
            else{
              this.anagraficaId = null;
            }
          },
          error: (err) => {
            this.codiceFiscaleFlag = true;
            this.iscrittoForm.get('anagrafica.codiceFiscale')?.setErrors({ invalid: true });
            this.message_service.add({
              severity: 'error',
              summary: 'Codice Fiscale Esistente',
              detail: err.error
            });
          }
        })
      }
    }
    else{
      this.disableForm();
    }
    this.modificaInCorsoFlag = false;
  }

  disableForm(){
    this.iscrittoForm.get('anagrafica.alias')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.sessoAlias')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.nome')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.cognome')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.sesso')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.luogoNascita')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.provinciaNascita')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.dataNascita')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.cittadinanza')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.permessoSoggiorno')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.permessoSoggiornoScadenza')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.permessoSoggiornoIllimitato')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.email')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.pec')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.telefonoPrincipale')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.prefissoTelefonoPrincipale')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.idTelefonoPrincipale')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.residenzaIndirizzo')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.residenzaCap')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.residenzaComune')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.residenzaProvincia')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.residenzaStato')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.residenzaLuogo')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.domicilioIndirizzo')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.domicilioCap')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.domicilioComune')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.domicilioProvincia')?.disable({emitEvent: false});
    this.iscrittoForm.get('anagrafica.domicilioLuogo')?.disable({emitEvent: false});
    this.iscrittoForm.get('albo')?.disable({emitEvent: false});
    this.iscrittoForm.get('titoli')?.disable({emitEvent: false});
  }

  loadAnagrafica(anagrafica: Anagrafica){
    const numeroPrincipaleEstratto = this.estraiNumeroPrincipale(anagrafica.telefoni);
    this.listaNumeriSecondari = this.estraiNumeriSecondari(anagrafica.telefoni);
    if(numeroPrincipaleEstratto !== null) this.selectedPrefisso = numeroPrincipaleEstratto.prefisso;

    this.iscrittoForm.patchValue({
      anagrafica: {
        alias: anagrafica.alias,
        sessoAlias: anagrafica.sessoAlias,
        nome: this.gestisciMaiuscole(anagrafica.nome),
        cognome: this.gestisciMaiuscole(anagrafica.cognome),
        sesso: anagrafica.sesso,
        luogoNascita: anagrafica.luogoNascita,
        provinciaNascita: anagrafica.provinciaNascita,
        dataNascita: anagrafica.dataNascita ? new Date(anagrafica.dataNascita) : null,
        cittadinanza: anagrafica.cittadinanza,
        permessoSoggiorno: anagrafica.permessoSoggiorno,
        permessoSoggiornoScadenza: anagrafica.permessoSoggiornoScadenza ? new Date(anagrafica.permessoSoggiornoScadenza) : null,
        permessoSoggiornoIllimitato: anagrafica.permessoSoggiornoIllimitato,
        email: (anagrafica.email) ? anagrafica.email.toLowerCase() : '',
        pec: (anagrafica.pec) ? anagrafica.pec.toLowerCase() : '',
        residenzaIndirizzo: anagrafica.residenzaIndirizzo,
        residenzaCap: anagrafica.residenzaCap,
        residenzaComune: anagrafica.residenzaComune,
        residenzaProvincia: anagrafica.residenzaProvincia,
        residenzaStato: anagrafica.residenzaStato,
        residenzaLuogo: anagrafica.residenzaLuogo,
        domicilioIndirizzo: anagrafica.domicilioIndirizzo,
        domicilioCap: anagrafica.domicilioCap,
        domicilioComune: anagrafica.domicilioComune,
        domicilioProvincia: anagrafica.domicilioProvincia,
        domicilioLuogo: anagrafica.domicilioLuogo,

        telefonoPrincipale: numeroPrincipaleEstratto?.numero,
        prefissoTelefonoPrincipale: numeroPrincipaleEstratto?.prefisso ? numeroPrincipaleEstratto?.prefisso : null,
        idTelefonoPrincipale: numeroPrincipaleEstratto?.id
      }
    });
  }

  parseLocalDateStringToDate(dateString: string): Date {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day); // Months are 0-based in JavaScript Date
  }

  confirmEliminazione(event: Event) {
    this.confirmationService.confirm({
      target: event.currentTarget as EventTarget,
      message: 'Eliminare il Provvisorio?',
      icon: 'pi pi-exclamation-triangle',
      rejectLabel: 'Annulla',
      rejectButtonStyleClass: 'rejectButton',
      acceptLabel: 'Conferma',
      accept: () => {
        this.eliminaProvvisorio();
      },
      reject: () => {}
    });
  }
  eliminaProvvisorio(){
    this.iscritti_service.eliminaProvvisorio(this.currentId).subscribe({
      next: () => {
        this.message_service.add({
          severity: 'success',
          summary: 'Eliminazione effettuata',
          detail: 'Provvisorio eliminato con successo',
          life: 1000
        });
        setTimeout(() => {
          this.router.navigate(['/gestione_albo/provvisori']);
        }, 1000)
      },
      error: err => {
        this.message_service.add({
          severity: 'error',
          summary: 'Eliminazione non riuscita',
          detail: err.error
        });
      }
    })
  }

  goToCancellati(){
    this.router.navigate(['/gestione_albo/cancellati'],
      { state: { codiceFiscale: this.iscrittoForm.get('anagrafica.codiceFiscale')?.value } });
  }

  stampaSchedaIscritto(){

    const idIscritto = this.infoOriginali?.id;

    this.print_service.stampaSchedaPersonale(idIscritto!).subscribe({
      next: result => {
        const blob = new Blob([result], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.infoOriginali?.anagrafica.cognome.toLowerCase()}_${this.infoOriginali?.anagrafica.nome.toLowerCase()}_scheda_personale.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      },
      error: err => {
        console.log(err.error);
      }
    })

  }

  stampaCertidficatoIscrizione(){

    const idIscritto = this.infoOriginali?.id;

    this.print_service.stampaCertificatoIscrizione(idIscritto!).subscribe({
      next: result => {
        const blob = new Blob([result], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        //window.open(url);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.infoOriginali?.anagrafica.cognome.toLowerCase()}_${this.infoOriginali?.anagrafica.nome.toLowerCase()}_certificato_iscrizione.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      },
      error: err => {
        console.log(err.error);
      }
    })

  }

  stampaCertidficatoIscrizioneEstero(){

    const idIscritto = this.infoOriginali?.id;

    this.print_service.stampaCertificatoIscrizioneEstero(idIscritto!).subscribe({
      next: result => {
        const blob = new Blob([result], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        //window.open(url);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.infoOriginali?.anagrafica.cognome.toLowerCase()}_${this.infoOriginali?.anagrafica.nome.toLowerCase()}_certificato_estero.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      },
      error: err => {
        console.log(err.error);
      }
    })

  }

  buildDate(data_in: Date){
    const day = String(data_in.getDate()).padStart(2, '0');
    const month = String(data_in.getMonth() + 1).padStart(2, '0');
    const year = String(data_in.getFullYear());

    const data = `${year}-${month}-${day}`;

    return data;
  }

  capitalizeFirstLetters(input: string): string {
    return input.split(' ').map(word => {
      if (word.length > 0) {
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      }
      return word;
    }).join(' ');
  }

  audiltLog: AuditLog[] = [];
  expandedRows = {};

  onChange($event: TabViewChangeEvent) {
    //console.debug("tab change", $event);
    //if (this.tabview?.tabPanels?.get($event.index)?.id === 'modifiche') {
    //if (this.tabview?.tabs[$event.index].header === 'Modifiche') {
/* non funziona nessuno di questi... */
      if ($event.index === 5) {
      console.debug("caricamento registro modifiche");
      const idIscritto = this.infoOriginali?.id;
      if (idIscritto)
        this.iscritti_service.getModificheIscritto(idIscritto).subscribe({
          next: (log)=>{
            this.audiltLog = log;
          }});

    }
  }

  onTelefonoChange(event: any, tipo: string) {
    const telefono = this.iscrittoForm.get('anagrafica.telefonoPrincipale');
    const prefisso = this.iscrittoForm.get('anagrafica.prefissoTelefonoPrincipale');
    if(tipo === 'telefono'){
      if(telefono?.value && telefono.value.trim() !== ''){
        prefisso?.setValidators([Validators.required, this.customPrefissoValidators()]);
      }
      else{
        prefisso?.setValidators([this.customPrefissoValidators()]);
      }
    }
    if(tipo === 'prefisso'){
      if(prefisso?.value){
        telefono?.setValidators([Validators.required, Validators.pattern(/^[0-9]+$/)]);
      }
      else{
        telefono?.setValidators([Validators.pattern(/^[0-9]+$/)]);
      }
    }
    telefono?.updateValueAndValidity();
    prefisso?.updateValueAndValidity();
  }

  expandAllLog() {
    this.expandedRows = this.audiltLog.reduce((acc:any, p) => (acc[p.eventId] = true) && acc, {});
  }

  collapseAllLog() {
      this.expandedRows = {};
  }


  stampaTesserino(useAlias: boolean) {

    const idIscritto = this.infoOriginali?.id;
    const obs  = useAlias ? this.print_service.stampaTesserinoAlias(idIscritto!) : this.print_service.stampaTesserino(idIscritto!);

    obs.subscribe({
      next: result => {
        const blob = new Blob([result], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        //window.open(url);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.infoOriginali?.anagrafica.cognome.toLowerCase()}_${this.infoOriginali?.anagrafica.nome.toLowerCase()}_tesserino.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      },
      error: err => {
        console.log(err.error);
      }
    })

  }
}
